import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ZorroTableComponent } from '../../common/custom-table/zorro-table.component';

@Component({
  selector: 'app-device-info-modal',
  standalone: true,
  imports: [CommonModule, ZorroTableComponent, MatTooltipModule],
  templateUrl: './device-info-modal.component.html',
  styleUrl: './device-info-modal.component.scss',
})
export class DeviceInfoModalComponent {
  activeModal = inject(NgbActiveModal);
  isActive = false;
  showPassword: any = {};

  @Input() device: any = {};

  isLocal(): boolean {
    return this.device?.environment?.toUpperCase() === 'LOCAL';
  }

  getEnvironmentLabel(): string {
    const env = this.device?.environment?.toUpperCase();
    if (env === 'LOCAL') return 'Local';
    if (env === 'REMOTE') return 'Remote';
    return this.device?.environment || '-';
  }

  getPlatformIcon(): string {
    const platform = this.device?.platform?.toLowerCase();
    if (platform === 'ios') return 'assets/images/virtusa-icons/ios.svg';
    if (platform === 'android') return 'assets/images/virtusa-icons/android.svg';
    return '';
  }

  getBadgeClass(deviceType: string): string {
    const type = deviceType?.toLowerCase().replace(/_/g, ' ');
    if (type === 'simulator') return 'simulator';
    return '';
  }

  remoteOptionsColumns = [
    {
      key: 'key',
      display_name: 'Key',
      headerStyles: { background: '#242933', color: '#fff', 'font-weight': '600', 'font-size': '13px' },
      cellStyles: { 'font-size': '13px' },
    },
    {
      key: 'value',
      display_name: 'Value',
      headerStyles: { background: '#242933', color: '#fff', 'font-weight': '600', 'font-size': '13px' },
      cellStyles: { 'font-size': '13px' },
    },
  ];

  remoteOptionsTableOptions = {
    showPagination: true,
    pageSize: 5,
  };

  getRemoteOptions(): { key: string; value: string }[] {
    const config = this.device?.config;
    if (!config) return [];
    if (Array.isArray(config)) return config;
    // Handle object shape: { key1: val1, key2: val2 }
    return Object.entries(config).map(([key, value]) => ({ key, value: String(value) }));
  }

  toggleAccessKeyVisibility(): void {
    this.showPassword['accessKey'] = !this.showPassword['accessKey'];
  }

  getMaskedAccessKey(): string {
    const key = this.device?.credentials?.accessKey || this.device?.accessKey;
    return key ? '•'.repeat(Math.min(key.length, 20)) : '-';
  }
}
